import {Component} from '@angular/core';
import {TaskOptionsService} from '../../../../services/task-options.service';
import {AlertService} from '../../../../services/notify/alert.service';
import {CrmService} from '../../../../services/api/crm.service';
import {TranslateService} from '@ngx-translate/core';

@Component({
    selector: 'app-task-global',
    templateUrl: './task-global.component.html',
    styleUrls: ['./task-global.component.scss']
})
export class TaskGlobalComponent {

    isShowIcons = false;
    icons = {
        selected: null,
        all: [
            'bi bi-alarm',
            'bi bi-archive',
            'bi bi-at',
            'bi bi-asterisk',
            'bi bi-bar-chart',
            'bi bi-bar-chart-steps',
            'bi bi-bell',
            'bi bi-box-seam',
            'bi bi-bricks',
            'bi bi-briefcase',
            'bi bi-buildings',
            'bi bi-calendar-date',
            'bi bi-camera',
            'bi bi-cash-stack',
            'bi bi-chat-dots',
            'bi bi-check2-all',
            'bi bi-easel',
            'bi bi-pen'
        ]
    };
    isLockButton = false;
    editGroup = false;

    constructor(
        public taskOptionsService: TaskOptionsService,
        public alert: AlertService,
        public crmService: CrmService,
        protected translate: TranslateService
    ) {
    }

    editGroupSelectedBoard(id: string): void {
        if (id) {
            this.taskOptionsService.selectedBoard.group_id = Number(id);
            this.taskOptionsService.groupSelectedBoard = this.taskOptionsService.boardsGroups.filter(x => x.id === Number(id))[0];
        } else {
            this.taskOptionsService.selectedBoard.group_id = null;
        }
        this.editGroup = false;
    }

    saveDashboard(): void {
        if (!this.taskOptionsService.selectedBoard.name) {
            return this.alert.setAlert(this.translate.instant('ALERTS.CREATE_BOARS_NAME'), 'blue');
        }

        const data = {
            name: this.taskOptionsService.selectedBoard.name,
            alias: this.taskOptionsService.selectedBoard.alias,
            icon: this.taskOptionsService.selectedBoard.icon,
            description: this.taskOptionsService.selectedBoard.description,
            group_id: this.taskOptionsService.selectedBoard.group_id,
        };
        this.isLockButton = true;

        this.crmService.updateBoard(this.taskOptionsService.selectedBoard.alias, data).subscribe({
            next: () => {
                void this.taskOptionsService.onLoadBoards(true);
                this.alert.setAlert(this.translate.instant('ALERTS.SUCCESS'), 'green');
                this.isShowIcons = false;
                this.isLockButton = false;
            }, error: error => {
                this.alert.setAlert(error.message, 'blue');
                this.isLockButton = false;
                this.taskOptionsService.selectedBoard = this.taskOptionsService.copySelectedBoard;
            }
        });
    }
}
